module.exports = __webpack_public_path__ + "images/picker_thumb.png";